import { useEffect, useRef } from 'react';

import {
  useGetApplicationQuery,
  useGetContext,
  useGetProfile,
  useGetSelectStateQuery,
  useGetStateQuery,
} from '../../api/lendingApi/lendingApiQueries';
import { normaliseStepDataDE } from '../../components/helpers/stateNormalisation';
import { getLatestStepDE } from '../../helpers/getLatestStep/getLatestStepDE';
import { TGetStateResponseDE } from '../../lapiOverrideTypesDE';
import { useContextStateKey } from '../useContextStateKey';
import { useSignupRouterDE } from '../useSignupRouter/useSignupRouterDE';

export const useAutoRoutingDE = () => {
  const stateKey = useContextStateKey();

  const hasRedirectedRef = useRef(false);

  const { isProfileErrored } = useGetProfile();
  const { context, contextStatus } = useGetContext();
  const { state } = useGetStateQuery<TGetStateResponseDE>();

  const { application, applicationStatus } = useGetApplicationQuery();

  const { normalisedState } = useGetSelectStateQuery((data) =>
    normaliseStepDataDE(data),
  );

  const { currentStep, navigateSignupDE, navigateToAccountPages } =
    useSignupRouterDE();

  // Stop future auto redirects if profile errors
  useEffect(() => {
    if (isProfileErrored) {
      hasRedirectedRef.current = true;
    }
  }, [isProfileErrored]);

  useEffect(() => {
    if (
      normalisedState &&
      typeof stateKey === 'string' &&
      applicationStatus === 'success' &&
      !hasRedirectedRef.current &&
      !isProfileErrored
    ) {
      if (application?.status === 'deferred') {
        void navigateSignupDE('neu', stateKey);
      }

      if (
        application?.status === 'offered' ||
        application?.is_closed ||
        context.user_signup_finished
      ) {
        return void navigateToAccountPages(stateKey);
      }

      hasRedirectedRef.current = true;

      const activeStep = normalisedState.ui?.activePartnerStep;
      const newStep = getLatestStepDE(state, application, activeStep);

      if (newStep !== currentStep) {
        void navigateSignupDE(newStep, stateKey, state);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [application, applicationStatus, contextStatus, context, normalisedState]);
};
